var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer mgmt-footer",attrs:{"id":"manager-footer"}},[_c('div',{staticClass:"inner default-w"},[_c('div',{staticClass:"txt-area"},[_c('p',{staticClass:"copyright"},[_vm._v("\n          Gangwon State Education Science & Information Institute. All Right Reserved.\n\t\t\t\t")])])])])
}]

export { render, staticRenderFns }